import { Component, h } from 'preact'
import axios, {AxiosResponse} from 'axios'
import FeaturedTopicView from './FeaturedTopicView'
import Button from '../ui-components/Button'

interface Author {
  id: number
  url: string
  name: string
  avatar: string
}

export interface Post {
  id: number
  author: Author
  content: string
  url: string
  creationDate: string
  relativeCreationDate: string
}

interface IdeationStatus {
  name: string
  bgColor: string
  color: string
}

interface FeaturedTopic {
  id: number
  title: string
  description: string
  url: string
  type: number
  featuredImage: string
  label: string
  replyCount: number
  views: number
  post: Post
  customClass: string
  likes: number
  hasCurrentUserLiked: boolean
  ideationStatus?: IdeationStatus
}

interface Props {
  title: string
  topicsFullWidth: number
  topicIds: number[]
  buttonLabel?: string
  buttonUrl?: string
}

interface State {
  featuredTopics: FeaturedTopic[]
}

export default class FeaturedTopicsWidget extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      featuredTopics: []
    }

    this.addLikeHandler = this.addLikeHandler.bind(this)
  }

  async componentDidMount () {
    const { data }: AxiosResponse<{content: FeaturedTopic[]}> = await axios.get('/homepage/featuredTopics', {
      params: {
        topicIds: this.props.topicIds
      }
    })

    this.setState({
      featuredTopics: data.content
    })
  }

  async addLikeHandler (index: number) {
    if (!window.inSidedData.user.userid) {
      const event = new window.Event('GuestUserAction')
      return window.dispatchEvent(event)
    }

    const newFeaturedTopics = [...this.state.featuredTopics]
    let { post, id, likes, hasCurrentUserLiked: liked } = newFeaturedTopics[index]

    newFeaturedTopics[index].likes = liked ? --likes : ++likes
    newFeaturedTopics[index].hasCurrentUserLiked = !liked

    this.setState({
      featuredTopics: newFeaturedTopics
    })

    const url = `/member/like?like=${newFeaturedTopics[index].hasCurrentUserLiked}&tid=${id}`

    const newData = {
      liked: newFeaturedTopics[index].hasCurrentUserLiked,
      postid: post.id
    }

    return await axios.post(url, { ...newData })
  }

  render (
    { title, topicsFullWidth, topicIds, buttonLabel = '', buttonUrl = '' }: Props,
    { featuredTopics }: State
  ) {
    if (!topicIds || !topicIds.length) {
      return null
    }

    let customClass = ''

    const externalLink = buttonUrl && (buttonUrl.indexOf(window.location.hostname) < 0)

    return (
      <section class='featured-topics qa-featured-topics-container sitewidth'>
        {title &&
          <h2 class='featured-topics__heading'>{title}</h2>
        }
        <ul class={`featured-topics__list ${featuredTopics.length === 1 ? 'featured-topics__list--no-slider' : ''}`}>
          { featuredTopics.map(({ likes, type, title, featuredImage, label, replyCount, views, url, post, ideationStatus, hasCurrentUserLiked }: FeaturedTopic, index: number) => {
            if (window.inSidedData?.device !== 'mobile' && index >= topicsFullWidth && ((featuredTopics.length - topicsFullWidth === 2) || (featuredTopics.length - topicsFullWidth === 4))) {
              customClass = 'featured-topic--half-width'
            }

            if (window.inSidedData?.device !== 'mobile' && index >= topicsFullWidth && (featuredTopics.length - topicsFullWidth === 1)) {
              customClass = 'featured-topic--full-width'
            }

            return (
              <FeaturedTopicView
                title={title}
                featuredImage={featuredImage}
                label={label}
                replyCount={replyCount}
                views={views}
                url={url}
                post={post}
                fullWidth={index < topicsFullWidth}
                customClass={customClass}
                type={type}
                likes={likes}
                addLikeHandler={this.addLikeHandler}
                index={index}
                ideationStatus={ideationStatus}
                hasCurrentUserLiked={hasCurrentUserLiked}
              />
          )})}
        </ul>
        {buttonLabel && buttonUrl &&
          <a
            class='featured-topics__show-more-button'
            href={buttonUrl}
            target={`${externalLink  ? '_blank' : '_self'}`}
            rel={`${externalLink ? 'noreferrer nofollow noopener' : ''}`}
          >
            <Button
              title={buttonLabel}
            />
          </a>
        }
      </section>
    )
  }
}
